import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Modal, Table } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { couponActions, planActions } from '../../actions';
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next';

import PageTitle from "../../components/common/PageTitle";
import date from '../../utils/date'

const PlansList = () => {
    const { SearchBar } = Search;
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isGregorian = true;
    // const user = useSelector(state => state.authentication.user);
    const loading = useSelector(state => state.plan.loading);
    const plans = useSelector(state => state.plan.plans);
    const [show, setShow] = useState(false);
    const [plansDetails, setPlansDetails] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState();
    const [redeemBy, setRedeemBy] = useState();
    const [confirm, setConfirm] = useState(false);
    const [editPlan, setEditPlan] = useState();
    const amountOffRef = useRef()
    const percentOffRef = useRef()
    const planAmountRef = useRef()
    const currencyRef = useRef()
    const selectedPlanRef = useRef()



    useEffect(() => {
        dispatch(planActions.getAll());
    }, [])

    useEffect(() => {
        console.log('redeemBy', redeemBy);;
    }, [redeemBy])

    useEffect(() => {
        if (!plansDetails) return;
        dispatch(couponActions.findAll());
    }, [plansDetails])

    useEffect(() => {
        if (plans.length < 1) return
        let plansList = []
        const sortedPlans = _.sortBy(plans, ['interval', 'intervalCount']);
        sortedPlans.map(plan => {
            // if (plan.amount) {
            const intervalNumber = plan.interval === 'day' ? 1 : (plan.interval === 'month' ? 2 : 3)
            const intervalCount = plan.intervalCount > 9 ? plan.intervalCount : `0${plan.intervalCount}`
            plansList.push(
                {
                    key: parseInt(`${intervalNumber}${intervalCount}`),
                    name: `${plan.intervalCount} ${_.capitalize(plan.interval)}`,
                    id: plan._id,
                    currency: plan.currency,
                    intervalCount: intervalCount,
                    amount: plan.amount,
                    interval: plan.interval,
                    active: plan.active,
                    updatedAt: plan.updatedAt,
                }
            )
        }
            // }
        )
        setPlansDetails(plansList);
    }, [plans])


    useEffect(() => {
        if (_.has(percentOffRef, 'current.value'))
            percentOffRef.current.value = 0
        if (_.has(selectedPlan, 'amount')) {
            amountOffRef.current.value = 0
            planAmountRef.current.value = _.get(selectedPlanRef, 'current.value') === 'all' ? 'All Plans' : `${_.get(selectedPlan, 'amount', '--')} ${_.get(selectedPlan, 'currency')}`
        }
    }, [selectedPlan])

    const handleClose = () => {
        if (confirm) setConfirm(false)
        else setShow(false);
    };
    const handleShow = () => {
        setShow(true);
    }

    const formik = useFormik({
        initialValues: {
            interval: '',
            intervalCount: '',
            active: true,
            amount: 0,
            currency: '',
            product: '5e5d3dbac93844e53153164e',
        },
        onSubmit: values => {
            if (!values.currency) delete values.currency;
            if (!values.plan) values.product = '5f04b8aa2de472a648cc1763';
            if (confirm) {
                setShow(false);
                dispatch(planActions.create(values))
                setConfirm(false);
            } else {
                setConfirm(true);
            }
            // formik.values.name = '';
        },

    });

    const columns = [
        {
            text: 'Plan',
            dataField: 'name',
        },
        {
            text: 'Status',
            dataField: 'active',
            formatter: cell => cell ? 'Active' : <span className="danger">Deactivated</span>,
        },
        {
            text: 'Amount',
            dataField: 'amount',
            formatter: cell => cell ? cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'Free',
        },
        {
            text: 'Currency',
            dataField: 'currency',
            formatter: (cell, row) => row.amount ? cell : '--',
        },
        {
            text: 'Last Update',
            dataField: 'updatedAt',
            formatter: cell => cell ? date(cell) : '--',
        },
        {
            text: 'Action',
            dataField: 'id',
            formatter: actionFormatter,
        }
    ]

    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                {row.active ?
                    <Button className="tableTempAction" variant="danger" onClick={() => setEditPlan({ id: cell, status: row.active })}><i className="material-icons"></i> Deactivate</Button>
                    :
                    <Button className="tableTempAction" variant="success" onClick={() => setEditPlan({ id: cell, status: row.active })}><i className="material-icons"></i> Active</Button>
                }
                {/* <Button className="tableTempAction" theme="info" onClick={() => detailsHandler(cell)}><i className="material-icons">info</i> Details</Button> */}
                {/* <Button className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
            </div>
        )
    }

    const editHandler = (referralId) => {
        history.push(`referral/${referralId}`);
    }

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
        },
        onPageChange: (page, sizePerPage) => {
        }
    };

    function customTotal(from, to, size) {
        return (
            <span className="react-bootstrap-table-pagination-total">
                Showing {from} to {to} of {size} Results
            </span>
        );
    }

    const activeHandler = () => {
        const plan = { planId: editPlan.id, active: true }
        dispatch(planActions.update(plan))
        setEditPlan(null);
    }

    const deactivateHandler = () => {
        const plan = { planId: editPlan.id, active: false }
        dispatch(planActions.update(plan))
        setEditPlan(null);
    }


    return (
        <Container fluid className={`main-content-container px-4 ${loading && 'blur'}`}>
            {/* Page Header */}
            <Row noGutters className="page-header py-4">
                <PageTitle sm="4" title="Plans" subtitle="Accounting" className="text-sm-left" />
                <Col className="headerButtonHolder">
                    <Button variant="success" onClick={handleShow}><i className="material-icons"></i> New</Button>
                    {/* <Button className="" variant="danger" onClick={() => history.push(`/referrals`)}><i className="material-icons"></i> Back</Button> */}
                </Col>
            </Row>
            <Row>
                <Col>
                    <ToolkitProvider
                        keyField="id"
                        data={plansDetails}
                        columns={columns}
                        search
                    >
                        {
                            props => (
                                <div>
                                    <SearchBar {...props.searchProps} />
                                    <hr />
                                    <BootstrapTable
                                        {...props.baseProps}
                                        pagination={paginationFactory(options)}
                                    />
                                </div>
                            )
                        }
                    </ToolkitProvider>
                </Col>
            </Row>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                // size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{confirm ? 'Please confirm new plan' : 'New plan'}</Modal.Title>
                </Modal.Header>
                <form id="form" onSubmit={formik.handleSubmit}>
                    {confirm ?
                        <Modal.Body>
                            <Table className="confirmTable" striped bordered>
                                <tbody>
                                    <tr>
                                        <td>Plan:</td>
                                        <td>{`${formik.values.intervalCount} ${formik.values.interval}`}</td>
                                    </tr>
                                    <tr>
                                        <td>Amount:</td>
                                        <td>{formik.values.amount ? `${formik.values.amount} ${formik.values.currency}` : 'Free'}</td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>
                                        <td>{formik.values.active ? 'Active' : 'Deactivated'}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Modal.Body>
                        :
                        <Modal.Body>
                            <Row>
                                <Col>
                                    <input hidden id="product" name="product" value={formik.values.product} onChange={formik.handleChange} />
                                    <span>Interval:</span>
                                    <select required id="interval" name="interval" value={formik.values.interval} onChange={formik.handleChange}>
                                        <option value="" hidden>--</option>
                                        <option value="day">Daily</option>
                                        <option value="month">Monthly</option>
                                        <option value="year">Yearly</option>
                                    </select>
                                </Col>
                                <Col>
                                    <span>Interval Count:</span>
                                    <input type="number" min="1" required id="intervalCount" name="intervalCount" value={formik.values.intervalCount} onChange={formik.handleChange} />
                                </Col>
                                <Col>
                                    <span>Validation:</span>
                                    <select required id="valid" name="valid" value={formik.values.valid} onChange={formik.handleChange}>
                                        <option value={true}>Valid</option>
                                        <option value={false}>Invalid</option>
                                    </select>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <span>Amount:</span>
                                    <input type="number" min="0" required id="amount" name="amount" value={formik.values.amount} onChange={formik.handleChange} />
                                </Col>
                                <Col>
                                    <span>Currency:</span>
                                    <select required disabled={!formik.values.amount} id="currency" name="currency" value={formik.values.currency} onChange={formik.handleChange}>
                                        <option value="" hidden>--</option>
                                        <option value='IRR'>IRR</option>
                                        <option value='EUR'>EUR</option>
                                    </select>
                                </Col>
                            </Row>
                        </Modal.Body>}
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>{confirm ? 'Edit' : 'Cancel'}</Button>
                        <Button type="submit" variant="primary">{confirm ? 'Confirm' : 'Create'}</Button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal
                show={editPlan}
                // onHide={ }
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                // size="lg"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        {_.get(editPlan, 'status') ? 'Do you want deactivate the plan?' : 'Do you want active the plan?'}
                    </Modal.Title>
                </Modal.Header>
                {/* <Modal.Body></Modal.Body> */}
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setEditPlan(null)}>Cancel</Button>
                    {_.get(editPlan, 'status') ?
                        <Button variant="warning" onClick={deactivateHandler}>Deactivate</Button>
                        :
                        <Button variant="success" onClick={activeHandler}>Active</Button>
                    }
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default PlansList;
